export default "i18n_MODULE";
